'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _changespercoder = require('./changespercoder.component');

var _changespercoder2 = _interopRequireDefault(_changespercoder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var changespercoderModule = _angular2.default.module('changespercoder', [_angularUiRouter2.default]).component('changespercoder', _changespercoder2.default);

exports.default = changespercoderModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/changespercoder/changespercoder.js